import { useEffect, useState } from "react";
import { CARD_MODAL_BREAKPOINT } from "./modalConstants";

/**
 * True when the viewport matches the mobile card-modal breakpoint. Drives the
 * recede animation, which only applies on mobile (desktop modals don't stack
 * with the iOS card-stack effect).
 */
export function useCardModalBreakpoint(): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    const mq = window.matchMedia(CARD_MODAL_BREAKPOINT);
    const update = (): void => setMatches(mq.matches);
    update();
    const controller = new AbortController();
    mq.addEventListener("change", update, { signal: controller.signal });
    return () => controller.abort();
  }, []);

  return matches;
}
